import api from '../api'

const BaseUrl = '/academy/api/AdminCourse'
const moocReportingProvider = {
  getReportTableInput() {
    return api.get(`${BaseUrl}/ReportTableInput`)
  },
  reportTable(params) {
    return api.post(`${BaseUrl}/ReportTable`, params)
  },
}

export default moocReportingProvider
